export enum OverrideType {
    Field,
    Section
}

export enum FieldOverride {
    RequiredOnRecord,
    RequiredOnCase,
    RecordPermissions,
    CasePermissions
}

export const FieldOverrideLabels = [
	{
		key: FieldOverride.RequiredOnRecord,
		label: "Required on Record"
	},
	{
		key: FieldOverride.RequiredOnCase,
		label: "Required on Case"
	},
	{
		key: FieldOverride.RecordPermissions,
		label: "Record Permissions"
	},
	{
		key: FieldOverride.CasePermissions,
		label: "Case Permissions"
	}
]

export enum SectionOverride {
    Layout,
    RecordPermissions,
    CasePermissions
}

export const SectionOverrideLabels = [
	{
		key: SectionOverride.Layout,
		label: "Layout"
	},
	{
		key: SectionOverride.RecordPermissions,
		label: "Record Permissions"
	},
	{
		key: SectionOverride.CasePermissions,
		label: "Case Permissions"
	}
]

export interface InheritanceOverrides {
    fields: { [id: string]: FieldOverride[] }
    sections: { [id: string]: SectionOverride[] }
}
